<template>
	<div>
		<MenuSectionHeader :menu="menu" />
		<div class="menu-section-title" v-if="featuredItems.length > 0">Featured</div>
		<div class="menu-featured-gallery" v-if="featuredItems.length > 0">
			<FeaturedMenuItem
				v-for="(featuredItem, i) in featuredItems"
				:key="i"
				:item="featuredItem"
			/>
		</div>
		<div v-for="menu in categorizedMenu" :key="menu.categoryId">
			<div v-if="menu.categoryId != -1" class="menu-section-title">
				{{ menu.categoryName }}
			</div>
			<div class="menu-items">
				<MenuItem
					v-for="item in menu.items"
					:key="item.id"
					:item="item"
					:data-cy="`menu-item-${item.id}`"
				/>
			</div>
		</div>
	</div>
</template>

<style scoped>
.menu-featured-gallery {
	display: flex;
	min-height: 192px;
}
</style>

<script>
import { UniqueProductLabelId } from "@/enums/UniqueProductLabelId"
import MenuSectionHeader from "@/components/menu/MenuSectionHeader.vue"
import FeaturedMenuItem from "@/components/menu/FeaturedMenuItem.vue"
import MenuItem from "@/components/menu/MenuItem.vue"
import mobileResponsivenessMixin from "@/mixins/mobile-responsiveness-mixin"

export default {
	name: "MenuSection",
	mixins: [mobileResponsivenessMixin],
	components: {
		MenuSectionHeader,
		FeaturedMenuItem,
		MenuItem
	},
	props: {
		menu: Object
	},
	computed: {
		totalFeaturedItems() {
			let totalFeaturedItems = 2
			if (this.windowSize.width > 500 && this.windowSize.width < 900) {
				totalFeaturedItems = 3
			} else if (this.windowSize.width >= 900) {
				totalFeaturedItems = 4
			}
			return totalFeaturedItems
		},
		featuredItems() {
			if (this.menu && this.menu.items) {
				return this.menu.items
					.filter((item) => {
						const labelIds = item.labels.map((label) => label.id)
						return labelIds.includes(UniqueProductLabelId.FEATURED)
					})
					.slice(0, this.totalFeaturedItems)
			}
		},
		categorizedMenu() {
			const categorizedItems = {}
			if (this.menu && this.menu.items) {
				this.menu.items.forEach((item) => {
					const categoryName = this.$store.state.categories[
						item.category_id
					]
					if (categoryName) {
						if (categorizedItems[item.category_id] == undefined) {
							categorizedItems[item.category_id] = {
								items: [],
								categoryName: categoryName,
								position: this.menu.categoryOrder.indexOf(
									item.category_id
								)
							}
						}
						categorizedItems[item.category_id].items.push(item)
					} else {
						if (categorizedItems["-1"] == undefined) {
							categorizedItems["-1"] = {
								items: [],
								position: -1
							}
						}
						categorizedItems["-1"].items.push(item)
					}
				})
			}
			return Object.values(categorizedItems).sort(
				(a, b) => a.position - b.position
			)
		}
	}
}
</script>